import React from 'react';

import SalonModal from 'components/dialog/SalonModal.component';
import Button from 'components/form/Button.component';
import Icon from 'components/generic/Icon.component';
import IconStatus from 'components/generic/IconStatus.component';
import S from 'constants/string.const';
import { useTranslation } from 'providers/GILT.provider';

import CN from './RebookAppointmentModal.module.scss';

const CheckoutButton = ({ width, onCheckout }) => {
  const { t } = useTranslation();
  return (
    <Button variant="primaryForce" onClick={onCheckout} xSpace width={width}>
      {t('scheduler.rebookAppointmentModal.checkoutButton')}
    </Button>
  );
};

const BackToTodayButton = ({ width, onToday }) => {
  const { t } = useTranslation();
  return (
    <Button variant="outlineForce" onClick={onToday} xSpace width={width}>
      {t('scheduler.rebookAppointmentModal.backButton')}
    </Button>
  );
};

const ViewNewBookingButton = ({ width, onClose }) => {
  const { t } = useTranslation();
  return (
    <Button variant="outlineForce" onClick={onClose} xSpace width={width}>
      {t('scheduler.rebookAppointmentModal.viewNewBookingButton')}
    </Button>
  );
};

const RebookAppointmentModal = ({ isOpen, onToday, onView, onCheckout, hideCheckout }) => {
  const { t } = useTranslation();

  return (
    <SalonModal tag="RebookAppointmentModal" isOpen={isOpen} withFooter>
      <SalonModal.Body>
        <IconStatus variant="success" width="lg" position="left">
          <Icon variant="confirm" width="xl" />
        </IconStatus>
        <div className={CN.modalContent}>
          <div className={CN.modalTitle}>{t('scheduler.rebookAppointmentModal.title')}</div>
          <div className={CN.modalText}>{t('scheduler.rebookAppointmentModal.subtitle')}</div>
          <div className={CN.modalBullet}>
            {S.dot} {t('scheduler.rebookAppointmentModal.bullet1')}
          </div>
          <div className={CN.modalBullet}>
            {S.dot} {t('scheduler.rebookAppointmentModal.bullet2')}
          </div>
          <div className={CN.modalBullet}>
            {S.dot} {t('scheduler.rebookAppointmentModal.bullet3')}
          </div>
        </div>
      </SalonModal.Body>
      <SalonModal.Footer>
        <div className={CN.desktopOrder}>
          <div className={CN.firstRow}>
            <BackToTodayButton onToday={onToday} />
            <ViewNewBookingButton onClose={onView} />
          </div>
          {!hideCheckout && <CheckoutButton onCheckout={onCheckout} />}
        </div>
        <div className={CN.mobileOrder}>
          <div className={CN.firstRow}>
            <div className={CN.half}>
              <BackToTodayButton width="fluid" onToday={onToday} />
            </div>
            {!hideCheckout && (
              <div className={CN.half}>
                <CheckoutButton width="fluid" onCheckout={onCheckout} />
              </div>
            )}
          </div>
          <ViewNewBookingButton width="fluid" onClose={onView} />
        </div>
      </SalonModal.Footer>
    </SalonModal>
  );
};

export default RebookAppointmentModal;
